import {
  isValidEmail,
  isValidMobile,
  isValidName,
  isValidPassword,
  getNotifMsg,
} from 'utils';

export const validateInviteOperator = (values, locale = 'fa') => {
  const { position, fullName, mobile, email, password, confirmPassword } =
    values;
  const errors = {};
  if (!position || position === '') {
    errors.position = getNotifMsg('ENTER_TITLE', locale);
  }
  if (!fullName || fullName === '') {
    errors.fullName = getNotifMsg('ENTER_NAME', locale);
  } else if (fullName.length < 3) {
    errors.fullName = getNotifMsg('NAME_CHAR_ERROR', locale);
  } else if (!isValidName(fullName)) {
    errors.fullName = getNotifMsg('CHAR_LENGTH_EXCEED', locale);
  }
  if (!email) {
    errors.email = getNotifMsg('ENTER_EMAIL', locale);
  } else if (!isValidEmail(email)) {
    errors.email = getNotifMsg('EMAIL_INVALID', locale);
  }
  if (!mobile) {
    errors.mobile = getNotifMsg('ENTER_MOBILE', locale);
  } else if (!isValidMobile(mobile)) {
    errors.mobile = getNotifMsg('INVALID_MOBILE', locale);
  }
  if (!password) {
    errors.password = getNotifMsg('ENTER_PASSWORD', locale);
  } else if (password.length <= 8) {
    errors.password = getNotifMsg('PASSWORD_LENGTH_INVALID', locale);
  } else if (!isValidPassword(password)) {
    errors.password = getNotifMsg('PASSWORD_INVALID_CHARS', locale);
  }
  if (!confirmPassword) {
    errors.confirmPassword = getNotifMsg('PASSWORD_INVALID_CHARS', locale);
  } else if (password !== confirmPassword) {
    errors.confirmPassword = getNotifMsg(
      'PASSWORD_REPETITION_NOT_VALID',
      locale
    );
  }
  if (position && fullName && position.trim() == fullName.trim()) {
    errors.fullName = getNotifMsg('TITL_AND_NAME_SHOULDNT_EQUAL', locale);
    errors.position = getNotifMsg('TITL_AND_NAME_SHOULDNT_EQUAL', locale);
  }
  return errors;
};
